export class NotificationData {
    constructor({
        id,
        isRead,
        checkDate,
        vesselName,
        alertRule,
        alertToBeExecuted
    }) {
        this.id = id;
        this.isRead = isRead;
        this.checkDate = checkDate;
        this.vesselName = vesselName;
        this.alertRule = alertRule;
        this.alertToBeExecuted = alertToBeExecuted;
    }
}
